<!-- desktop component -->
<div *appIsDesktop>
  <div class="last-quotes-header">
    <h2 mat-dialog-title>{{ appStrings.products_lastTenOpenQuotes }}</h2>
    <span class="close-button crm-industrial-font icon-remove" id="closeLastQuotesPopup" (click)="close()"></span>
  </div>
  <mat-divider></mat-divider>

  <div class="quotes-search-container">
    <app-last-quotes-search (filterChanged)="retrieveQuotes($event)" [customer]="data.customer"></app-last-quotes-search>
  </div>

  <table id="openQuotesTable" mat-table [dataSource]="quoteList" class="isc-table">
    <ng-container matColumnDef="accountName">
      <th mat-header-cell *matHeaderCellDef>{{ appStrings.quoteSearch_customerName }}</th>
      <td mat-cell *matCellDef="let quote;let index = index" [id]="appStrings.quoteSearch_customerName+'_'+index">
        {{ quote.accountName }}
      </td>
    </ng-container>
    <ng-container matColumnDef="confidence">
      <th mat-header-cell *matHeaderCellDef class="text-center">{{ appStrings.quoteSearch_confidencePct }}</th>
      <td mat-cell *matCellDef="let quote;let index = index" class="text-center"
        [id]="appStrings.quoteSearch_confidencePct+'_'+index">
        {{ ConfidenceToCloseNames[ConfidenceToClose[quote.confidenceToClosePercentageId]] }}
      </td>
    </ng-container>
    <ng-container matColumnDef="quoteNumber">
      <th mat-header-cell *matHeaderCellDef>{{ appStrings.quote_quoteNumber }}</th>
      <td mat-cell *matCellDef="let quote;let index = index" [id]="appStrings.quote_quoteNumber+'_'+index">
        <span>{{ quote.quoteNumber }}</span>
      </td>
    </ng-container>
    <ng-container matColumnDef="expiredDate">
      <th mat-header-cell *matHeaderCellDef>{{ appStrings.label_expiredDate }}</th>
      <td mat-cell *matCellDef="let quote;let index = index" [id]="appStrings.label_expiredDate+'_'+index">
        {{ quote.expiredDate | date: dateFormat }}
      </td>
    </ng-container>
    <ng-container matColumnDef="total">
      <th mat-header-cell *matHeaderCellDef class="total-header">{{ appStrings.label_total }}</th>
      <td mat-cell *matCellDef="let quote;let index = index" [id]="appStrings.label_total+'_'+index" class="total">
        {{ (quote.total) ? (quote.total | currency: quote.currencySign) : '' }}
      </td>
    </ng-container>

    <ng-container matColumnDef="action">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let quote; let index = index" class="action-container">
        <button id="addToQuoteButton" mat-button class="button primary" (click)="addToQuote(quote)"
          [disabled]="quote.quoteStatusId === quoteStatus.Expired || quote.quoteType === quoteType.Consigned">
          {{ appStrings.products_addToQuote }}
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;" [ngClass]="{expired: row.quoteStatusId===2}"></tr>
  </table>

  @if (!quoteList?.length) {
    <div id="emptyOpenQuotesList" class="no-results">
      {{ appStrings.noEntriesFound }}
    </div>
  }
</div>

<!-- mobile template -->
<div *appIsMobile class="mobile">
  @if (isLoading) {
    <div class="overlay full" id="productDetails-loadingSpinner">
      <p class="text-center">{{ appStrings.pleaseWait }}</p>
      <mat-spinner id="productsLoader"></mat-spinner>
    </div>
  }

  <div class="last-quotes-header">
    <div class="title">
      <span>{{ appStrings.button_addToQuote }}</span>
    </div>
    <span class="close-button crm-industrial-font icon-remove" id="closeLastQuotesPopup" (click)="close()"></span>
  </div>

  <div class="quotes-search-container">
    <app-last-quotes-search (filterChanged)="retrieveQuotes($event)" [customer]="data.customer"></app-last-quotes-search>
  </div>

  @if (quoteList.length > 0) {
    <div class="subtitle">
      <span>{{ appStrings.products_lastTenOpenQuotes }}</span>
    </div>
  }

  @if (quoteList.length === 0) {
    <div class="no-results">
      <span>{{ appStrings.noResultsForFilters }}</span>
    </div>
  }

  <div class="last-quotes-container">
    @for (quote of quoteList; track quote; let index = $index) {
      <div>
        <mat-expansion-panel hideToggle id="quoteInfoContainer" class="quote-info grey blue-border" [expanded]="quote.open">
          <mat-expansion-panel-header id="quoteInfoHeader">
            <div class="accordion-header">
              <div class="quote-details">
                <h3 id="quoteLabel" class="quote-label">{{ quote.accountName }}</h3>
                @if (quote.total) {
                  <span class="quote-total small-font"> {{ quote.total | currency: quote.currencySign }}</span>
                }
              </div>
              <div class="quote-actions">
                <button id="addToQuoteButton" mat-button class="button primary small-font" (click)="addToQuote(quote)"
                  [disabled]="quote.quoteStatusId === quoteStatus.Expired || quote.quoteType === quoteType.Consigned">
                  {{ appStrings.button_add }}
                </button>
                <span id="quoteHeaderClosed" class="crm-industrial-font icon-keyboard-arrow-up"></span>
                <span id="quoteHeaderOpened" class="crm-industrial-font icon-keyboard-arrow-down"></span>
              </div>
            </div>
          </mat-expansion-panel-header>
          <div id="quoteDetails" class="accordion-content">
            <div class="quote-detail">
              <span class="label">{{ appStrings.quoteSearch_bpNumber }}</span>
              <span class="data">{{ quote.bpNumber }}</span>
            </div>
            <div class="quote-detail">
              <span class="label">{{ appStrings.quote_quoteNumber }}</span>
              <span class="data">{{ quote.quoteNumber }}</span>
            </div>
            <div class="quote-detail">
              <span class="label">{{ appStrings.quoteSearch_confidencePct }}</span>
              <span class="data">{{ ConfidenceToCloseNames[ConfidenceToClose[quote.confidenceToClosePercentageId]] }}</span>
            </div>
            <div class="quote-detail">
              <span class="label">{{ appStrings.label_expiredDate }}</span>
              <span class="data small-font">{{ quote.expiredDate | date: dateFormat }}</span>
            </div>
          </div>
        </mat-expansion-panel>
      </div>
    }
  </div>
  <div class="close-button-container">
    <button type="button" id="closeButton" mat-button class="button mat-button" (click)="close()">
      <span>{{appStrings.button_close}}</span>
    </button>
  </div>
</div>